import React from 'react';

import { useTranslations } from '@lang';
import { CollectIcon, PostIcon } from '@root/styles/icons';
import { Property } from 'shared-types/Property';

import { List, ListItem } from './PostageOptions.styles';

type PostageOptionsProps = {
  property: Property;
};

export const PostageOptions: React.FC<PostageOptionsProps> = ({ property }) => {
  const { t } = useTranslations();

  return (
    <List>
      {property.deliveryEmail && (
        <ListItem>
          <PostIcon data-cy="post-icon" />
          <h4 data-cy="email-delivery-heading">{t('product.emailDeliveryHeading')}</h4>
        </ListItem>
      )}
      {property.deliveryCollection && (
        <ListItem>
          <CollectIcon data-cy="collect-icon" />
          <h4 data-cy="collection-delivery-heading">{t('product.collectionDeliveryHeading')}</h4>
        </ListItem>
      )}
      {property.deliveryPost && (
        <ListItem>
          <PostIcon data-cy="post-icon" />
          <h4 data-cy="postal-delivery-heading">{t('product.postalDeliveryHeading')}</h4>
        </ListItem>
      )}
    </List>
  );
};
